<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="code" label="手术代码" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="手术代码" v-model="form.code"></el-input>
              </el-form-item>
              <span class="viewText" v-else>手术代码:{{ form.code }} </span>
            </el-col>
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="name" label="手术名称" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="手术名称" v-model="form.name"></el-input>
              </el-form-item>
              <span class="viewText" v-else>手术名称:{{ form.name }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="category" label="手术类型" v-if="getIsView()">
                <el-select v-model="form.category" :disabled="!editMode" placeholder="请选择" filterable
                  style="width: 100%">
                  <el-option v-for="item in STATIC_Operation" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>手术类型:{{ form.category }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="手术等级" prop="level" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="手术等级" v-model="form.level"></el-input>
              </el-form-item>
              <span class="viewText" v-else>手术等级:{{ form.level }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="手术部位" prop="surgicalPart" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="手术部位" v-model="form.surgicalPart"></el-input>
              </el-form-item>
              <span class="viewText" v-else>手术部位:{{ form.surgicalPart }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="切口类型" prop="incisionCategory" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="切口类型" v-model="form.incisionCategory"></el-input>
              </el-form-item>
              <span class="viewText" v-else>切口类型:{{ form.incisionCategory }} </span>
            </el-col>
            <el-col :span="8" :class="!getIsView()?'viewCol':''">
              <el-form-item label="手术要求" prop="surgicalAsk" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="手术要求" v-model="form.surgicalAsk"></el-input>
              </el-form-item>
              <span class="viewText" v-else>手术要求:{{ form.surgicalAsk }} </span>
            </el-col>
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierIds" label="跟台供应商" v-if="getIsView()">
                <el-select v-model="form.supplierIdArr" :disabled="!editMode" placeholder="请选择" filterable multiple
                  :filter-method="getSuppliers" @change="supplierChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>跟台供应商:{{ form.supplierIds }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="assistant" label="跟台协助人" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="跟台协助人" v-model="form.assistant"></el-input>
              </el-form-item>
              <span class="viewText" v-else>跟台协助人:{{ form.assistant }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="phone" label="联系方式" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="联系方式" v-model="form.phone"></el-input>
              </el-form-item>
              <span class="viewText" v-else>联系方式:{{ form.phone }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="创建人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>创建人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
          </el-row>

          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">手术主要耗材明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" v-preventReClick type="danger"
              @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px"
            @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column prop="productName" label="产品" fixed width="180">
              <template slot-scope="scope">
                <SelectTable :disabled="!editMode" :columns="supplierProductColumns" :placeholder="'请选择产品'"
                  :innerName="scope.row.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList"
                  @change="(val) => productChange(scope.row, val)" />
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" fixed label="产品规格" width="180"></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
            <!-- <el-table-column prop="brand" label="品牌" width="120"></el-table-column> -->
            <el-table-column show-overflow-tooltip prop="supplierName" label="供应商" width="180"></el-table-column>
            <el-table-column prop="unit" label="包装单位" width="100"></el-table-column>
            <el-table-column prop="minUnit" label="最小单位" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
            <el-table-column prop="number" label="数量" min-width="130">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入数量" type="number" :id="'number' + scope.$index" min="0"
                  @input="inputChange(scope.row)" v-model="scope.row.number"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入备注" v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
              width="200"></el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <template>
        <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
        <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
        <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
          定</my-button>
        <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { GetSurgicalStentById, RejectSurgicalStent, SaveSurgicalStent } from "@/api";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data () {
    return {
      GetDataAction: GetSurgicalStentById,
      SaveDataAction: SaveSurgicalStent,
      reject: RejectSurgicalStent,
      form: {},
      rules: {
        name: [{ required: true, message: "请输入手术名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入手术代码", trigger: "blur" }],
      },
      childFormRules: {
        price: [{ required: true, message: "请输入采购价", trigger: "blur" }],
        number: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      // dateDisabled: false
      // 手术类型枚举
      STATIC_Operation: [
        {
          name: "初次单髁",
          id: 0,
        },
        {
          name: "初次全膝",
          id: 1,
        },
        {
          name: "初次全髋",
          id: 2,
        },
        {
          name: "初次半髋",
          id: 3,
        },
        {
          name: "翻修",
          id: 4,
        },
      ],
      supplierIdArr: [],
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getProductList("");
    this.getSuppliers("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.resetForm();
        this.form = res.returnData;
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

        if (res.returnData.supplierInfos) {
          res.returnData.supplierInfos.map((e) => {
            var supplier = this.STATIC_Suppliers.filter((s) => s.id == e.id);
            if (!supplier || supplier.length == 0) {
              this.STATIC_Suppliers.push(e);
            }
          });
        }

        if (res.returnData.supplierIds) {
          let arr = res.returnData.supplierIds.split(";").map((item) => item * 1); // 字符串转int
          this.$set(this.form, "supplierIdArr", arr);
        }
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        var valdateResult = this.productDetailRepeatValidate(this.form.details);
        if (!valdateResult.flag) {
          this.$my_message(valdateResult.msg, "warning");
          return;
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(
            this.getMainPath(this.$route.path),
            this.$route.params
          );
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        totalNumber: 0,
        totalAmount: 0,
        category: "",
        remark: "",
        name: "",
        supplierIdArr: [],
        details: [],
        state: 1, // 待供应商确认
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.form.details.push(this.childForm);
      this.autoTotalAmount();

      this.getProductList("");
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // // 打开子表弹窗
      // this.openSubformModal = true;
      // this.editChildren = true;
      // this.resetDetailFormData();
      // this.childForm = JSON.parse(JSON.stringify(row));
      // this.childForm.details.forEach((e, index) => {
      //   e.$index = index + 1;
      // });
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: "",
        productName: "",
        specName: "",
        manufacturerName: "",
        locationName: "",
        mainNo: "",
        traceNo: "",
        productId: "",
        specId: "",
        productRegistCertNo: "",
        onlineNo: "",
        unit: "",
        minUnit: "",
        packSpec: "",
        manufacturerId: "",
        locationId: "",
        manufactureDate: "",
        batch: "",
        validityDate: "",
        serialNo: "",
        number: 1,
        price: 0,
        amount: 0,
        remark: "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList("");
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find((e) => e.$index == this.childForm.$index);
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
    },

    // change event
    supplierChange (val) {
      this.form.supplierIds = val.join(";");
      // this.form.supplierName = this.STATIC_Suppliers.filter(item => item.id == val)[0].name
      this.getProductList("");
    },
    productChange (row, val) {
      // let arr = this.STATIC_SupplierProducts.filter(item => item.id == val.id)
      let id = row.id;
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      row = Object.assign(row, val); // this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      row.id = id;
      row.supplierProductId = val.id;
      row.number = 1;
      row.stockNumber = 0;
      row.price = row.purchasePrice;
      row.amount = row.price * row.number;
      row.supplierProductNo = row.no;
      row.remark = "";

      this.autoTotalAmount();

      this.$refs.childForm.validateField("productName");

      setTimeout(() => {
        document.getElementById("number" + (row.$index - 1)).focus();
        document.getElementById("number" + (row.$index - 1)).select();
      }, 1);
    },
    inputChange (row) {
      row.amount = row.price * row.number;
      this.autoTotalAmount();
    },

    getProductList (keyWord) {
      // query.pageIndex = 1
      // query.pageSize = 100
      // query.supplierId = this.form.supplierId
      // query.status = 2
      this.getSupplierProducts(
        //query)
        {
          keyWord: keyWord,
          pageIndex: 1,
          pageSize: 100,
          supplierId: this.form.supplierId,
          status: 2,
        }
      );
    },

    //other
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
